const searchInitialState = {
  doors:         [],
  information:   [],
  loading:       false,
  news:          [],
  open:          false,
  pages:         [],
  searchHistory: [],
  searched:      false,
};

export default searchInitialState;